
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useExportDialogStore = defineStore('exportDialog', () => {
  const isOpen = ref(false);
  const moduleName = ref<string | null>(null);
  const filters = ref<Record<string, any>>({});
  const exportCsv = ref<null | ((params: any) => Promise<any>)>(null);
  const fileName = ref<string | null>(null);

  const openDialog = (data: { moduleName: string, filters?: Record<string, any>, exportCsv?: ((params: any) => Promise<any>), fileName: string }) => {
    moduleName.value = data.moduleName;
    filters.value = data.filters || {};
    exportCsv.value = data.exportCsv || null;
    isOpen.value = true;
    fileName.value = data.fileName
  };

  const closeDialog = () => {
    isOpen.value = false;
    moduleName.value = null;
    filters.value = {};
    exportCsv.value = null;
    fileName.value = null;
  };

  return {
    isOpen,
    openDialog,
    closeDialog,
    moduleName,
    filters,
    exportCsv,
    fileName
  };
});
